import * as React from 'react';
import { Format } from 'nomst/Stores/Utility/format';
import AmountConvert from 'common/amountConvert';
import './compPagePayInfo.scss';

export interface ICompPagePayInfoProps {
    value: number;
    currencyCode: string;
    format: Format;
    isNewPay?: boolean;
    isHourly?: boolean;
    fullTimeEquivalent?: number;
}

const CompPagePayInfo = (props: ICompPagePayInfoProps): React.ReactElement => {
    const { value, isNewPay, format, isHourly, currencyCode, fullTimeEquivalent } = props;
    const title = isNewPay ? 'New Pay' : 'Current Pay';
    const className = isNewPay ? 'comp-page-pay-info--new' : 'comp-page-pay-info--current';

    const renderAnnualizedValue = () => {
        if (!isHourly) {
            return null;
        }

        const annualizedValue = AmountConvert.convertToAnnual(
            value,
            AmountConvert.annualStandardWorkHours,
            true,
            fullTimeEquivalent ?? 1);

        return (
            <p className="comp-page-pay-info__annual-value">
                {format.formatCurrencyValue(currencyCode, annualizedValue, false)}
            </p>
        );
    };

    return (
        <div className={`comp-page-pay-info ${className}`}>
            <p className="comp-page-pay-info__title">{title}</p>
            <p className="comp-page-pay-info__value">
                {format.formatCurrencyValue(currencyCode, value, !!isHourly)}
                {isHourly && <span className="comp-page-pay-info__hourly-label">&#47;hour</span>}
            </p>
            {renderAnnualizedValue()}
        </div>
    );
};

export default CompPagePayInfo;
export { CompPagePayInfo };